import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';

interface Props {
  isOpen: boolean;
  title: string;
  message: string;
  dismissButtonText: string;
  confirmButtonText: string;
  dismissButtonAction: () => void;
  confirmButtonAction: () => void;
}

const ConfirmationDialog: React.FC<Props> = (props) => {
  const {
    isOpen,
    title,
    message,
    dismissButtonText,
    confirmButtonText,
    dismissButtonAction,
    confirmButtonAction,
  } = props;

  const handleDismiss = (): void => {
    dismissButtonAction();
  };

  const handleConfirm = (): void => {
    confirmButtonAction();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleDismiss}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDismiss} color='primary'>
          {dismissButtonText.toUpperCase()}
        </Button>
        <Button onClick={handleConfirm} color='primary' autoFocus>
          {confirmButtonText.toUpperCase()}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
